import React from "react";

function MainSectionMask({color="#52A8F2",className,lineClassName}:{
  color?:string
  className?:string
  lineClassName?:string
}) {
  return (
    <div className={`absolute lg:end-[18%] lg:top-[-12rem]  end-[-89px] top-[-30px] ${className}`}>
      <div
        style={{ background:color }}
        className="h-[178px] w-[178px] lg:w-[18.7rem] lg:h-[18.7rem] rounded-full "
      ></div>
      <div
        style={{ background: color}}
        className={`w-[36px] lg:w-[3.7rem] lg:end-[7.4rem] lg:!h-[54rem] h-[949px] absolute rounded-[100px] top-0 end-[69px] ${lineClassName}`}
      ></div>
    </div>
  );
}

export default MainSectionMask;
